module.exports = __webpack_public_path__ + "static/media/map.2ea06bf8.png";